import $ from 'jquery';

var multiSelect = function multiSelect(uniq) {
  var $uniq = $(uniq);
  var $uniqEl = $(uniq)[0];
  var $content = $uniq.parents('.individual-accordion').find('.collapse')[0];
  var promise = new Promise(function (resolve) {
    var uniqArrow;

    for (var i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      }
    }

    resolve(uniqArrow);
  });
  promise.then(function (uniqArrow) {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $(uniqArrow).removeClass('down').addClass('right');
      $($uniqEl).removeClass('active').removeAttr('data-ct-ignore').attr('aria-expanded', false);
    } else {
      $($content).slideDown().addClass('shows');
      $($uniqEl).addClass('active').attr({
        'data-ct-ignore': true,
        'aria-expanded': true
      });
      $(uniqArrow).removeClass('right').addClass('down');
    }
  });
};

var singleSelect = function singleSelect(uniq) {
  var $uniq = $(uniq);
  var $uniqEl = $(uniq)[0];
  var $content = $uniq.parents('.individual-accordion').find('.collapse')[0];
  var promise = new Promise(function (resolve) {
    var uniqArrow;

    for (var i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      }
    }

    resolve(uniqArrow);
  });
  promise.then(function (uniqArrow) {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $(uniqArrow).removeClass('down').addClass('right');
      $($uniqEl).removeClass('active').removeAttr('data-ct-ignore').attr('aria-expanded', false);
    } else {
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('.collapse.single-slct').slideUp().removeClass('shows');
      $($content).slideDown().addClass('shows');
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('.accordion-title-single').removeClass('active').attr('aria-expanded', false);
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('svg').removeClass('down').addClass('right');
      $($uniqEl).addClass('active').attr({
        'data-ct-ignore': true,
        'aria-expanded': true
      });
      $(uniqArrow).removeClass('right').addClass('down');
    }
  });
};

var toggleAccordion = function toggleAccordion(uniq) {
  var $uniq = $(uniq);
  var $uniqEl = $(uniq)[0];
  var $content = $uniq.parents('.individual-inline-accordion, .show-more-expander').find('.collapse')[0];
  var controlText = $uniq.parents('.individual-inline-accordion, .show-more-expander').find('.expand-control-text')[0];
  var promise = new Promise(function (resolve) {
    var collapseText;
    var expandText;

    for (var i = controlText.attributes.length - 1; i >= 0; i -= 1) {
      if (controlText.attributes[i].name === 'data-accordion-collapse-text') {
        collapseText = controlText.attributes[i].value;
      } else if (controlText.attributes[i].name === 'data-accordion-expand-text') {
        expandText = controlText.attributes[i].value;
      }
    }

    var attrs = {
      collapseText: collapseText,
      expandText: expandText
    };
    resolve(attrs);
  });
  promise.then(function (attrs) {
    var uniqArrow;
    var uniqCtrlText;

    for (var i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      } else if ($uniqEl.children[i].classList.contains('expand-control-text')) {
        uniqCtrlText = $uniqEl.children[i];
      }
    }

    var allItems = Object.assign({}, attrs, {
      uniqArrow: uniqArrow,
      uniqCtrlText: uniqCtrlText
    });
    return allItems;
  }).then(function (allItems) {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $(allItems.uniqArrow).removeClass('down up').addClass('right');
      $(allItems.uniqCtrlText).html(allItems.expandText).removeAttr('data-ct-ignore').attr('aria-expanded', false);
    } else {
      $($content).slideDown().addClass('shows');

      if ($(allItems.uniqArrow).parents('.show-more-control-inline')[0]) {
        $(allItems.uniqArrow).removeClass('right').addClass('up');
      } else {
        $(allItems.uniqArrow).removeClass('right').addClass('down');
      }

      $(allItems.uniqCtrlText).html(allItems.collapseText).attr({
        'data-ct-ignore': true,
        'aria-expanded': true
      });
    }
  });
};

export var initMultiSelect = function initMultiSelect() {
  $(document).on('click', '.accordion-title', function (e) {
    e.preventDefault();
    multiSelect(e.currentTarget);
  });
};
export var initSingleSelect = function initSingleSelect() {
  $(document).on('click', '.accordion-title-single', function (e) {
    if ($(e.currentTarget).find('.mobile-childless-spacing').length <= 0) {
      e.preventDefault();
      singleSelect(e.currentTarget);
    }
  });
};
export var initInlineSelect = function initInlineSelect() {
  $(document).on('click', '.accordion-control-inline, .show-more-control-inline', function (e) {
    e.preventDefault();
    toggleAccordion(e.currentTarget);
  });
};
export var initExpDefault = function initExpDefault() {
  var expDef = $('.exp-default').children('button');
  expDef.each(function (index, el) {
    return multiSelect(el);
  });
};
export var initAllSelect = function initAllSelect() {
  $(document).on('click', '.accordion-controls button', function (e) {
    e.preventDefault();
    var $this = $(e.currentTarget);
    var $accordionBlock = $this.parents('.heavy-accordion-holder, .light-accordion-holder').first().find('button[data-ct-header="true"]');
    var $uniqRows;

    if ($this.hasClass('expand-all')) {
      $uniqRows = $($accordionBlock).not('.active');
    } else {
      $uniqRows = $($accordionBlock).filter('.active');
    }

    $uniqRows.each(function (index, el) {
      return multiSelect(el);
    });
  });
};
export default (function () {
  initMultiSelect();
  initSingleSelect();
  initInlineSelect();
  initExpDefault();
  initAllSelect();
});